export class WsError {
  constructor(public code: number, public message: string) {}
}
